import type { ReactNode } from 'react';
import { Switch } from './Switch';

interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
  /** The visible label; without one, pass `aria-label`. */
  children?: ReactNode;
  'aria-label'?: string;
}

/**
 * Design review 2 Nov 2026: an on/off option in a settings list is a toggle switch, not a checkbox. The existing `Switch`
 * look, announced as a switch and reporting a plain boolean. In a settings list it saves at once (the screen's own handler).
 */
export function Toggle({ checked, onCheckedChange, children, ...rest }: ToggleProps) {
  return (
    <Switch role="switch" checked={checked} onChange={(event) => onCheckedChange(event.target.checked)} {...rest}>
      {children}
    </Switch>
  );
}
